/*
 * Fixed above the mobile bottom navigation (56px) with a spacing-2 gap: 72px from the bottom.
 * The design's 24px offset would put the button on top of the nav.
 */
.add {
  position: fixed;
  right: var(--tuna-spacing-2);
  bottom: calc(56px + var(--tuna-spacing-2) + env(safe-area-inset-bottom, 0px));
  z-index: 1000;
}
